"use strict";
/*
 * Created on 8.12.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author MSu
 */


var LockActionResultConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(LockActionResultConverter, _DataObjectConverter_);

  function LockActionResultConverter() {
    _classCallCheck(this, LockActionResultConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(LockActionResultConverter).apply(this, arguments));
  }

  return LockActionResultConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.LockActionResultConverter = LockActionResultConverter;